(function () {
  if (window.__tasteFrozenAddWarningV3) return;
  window.__tasteFrozenAddWarningV3 = true;

  var FROZEN_VARIANTS = new Set([
    '48196090691796',
    '48196090757332',
    '48196090790100',
    '48196090724564',
    '48196090495188'
  ]);

  var lastShown = 0;

  function normalizeId(value) {
    if (!value) return '';
    var match = String(value).match(/(\d{8,})/g);
    return match ? match[match.length - 1] : String(value).trim();
  }

  function isFrozen(id) {
    return FROZEN_VARIANTS.has(normalizeId(id));
  }

  function showWarning() {
    var now = Date.now();
    if (now - lastShown < 1000) return;
    lastShown = now;

    var old = document.getElementById('taste-frozen-warning-overlay-v3');
    if (old) old.remove();

    var overlay = document.createElement('div');
    overlay.id = 'taste-frozen-warning-overlay-v3';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.style.cssText = 'position:fixed!important;inset:0!important;z-index:2147483647!important;background:rgba(0,0,0,.62)!important;display:flex!important;align-items:center!important;justify-content:center!important;padding:20px!important;box-sizing:border-box!important;';

    overlay.innerHTML = '<div style="width:min(92vw,480px)!important;background:#fff!important;color:#111!important;border-radius:18px!important;padding:30px 24px!important;box-shadow:0 20px 70px rgba(0,0,0,.4)!important;text-align:center!important;font-family:Arial,sans-serif!important;position:relative!important;">' +
      '<div style="font-size:48px!important;line-height:1!important;margin-bottom:12px!important;">❄️</div>' +
      '<div style="font-size:25px!important;font-weight:800!important;margin-bottom:12px!important;">Frozen Item Added</div>' +
      '<div style="font-size:16px!important;line-height:1.55!important;margin-bottom:22px!important;">This is a frozen item. Please choose <strong>Express Shipping (1–2 business days)</strong> or <strong>Same-Day Local Delivery</strong>.</div>' +
      '<button type="button" id="taste-frozen-warning-close-v3" style="border:0!important;border-radius:10px!important;padding:13px 30px!important;font-size:16px!important;font-weight:700!important;background:#111!important;color:#fff!important;cursor:pointer!important;">OK</button>' +
      '</div>';

    document.body.appendChild(overlay);
    var close = document.getElementById('taste-frozen-warning-close-v3');
    if (close) close.addEventListener('click', function () { overlay.remove(); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.remove(); });
  }

  function variantFromForm(form) {
    if (!form) return '';
    var idInput = form.querySelector('[name="id"]');
    if (idInput && idInput.value) return normalizeId(idInput.value);
    try {
      var fd = new FormData(form);
      var id = fd.get('id');
      if (id) return normalizeId(id);
    } catch (e) {}
    return '';
  }

  function variantFromElement(el) {
    if (!el) return '';
    var attrs = ['data-variant-id','data-product-variant-id','data-id','value'];
    for (var i = 0; i < attrs.length; i++) {
      var v = el.getAttribute && el.getAttribute(attrs[i]);
      if (v && isFrozen(v)) return normalizeId(v);
    }
    var form = el.closest && el.closest('form[action*="/cart/add"], form[action*="cart/add"]');
    return variantFromForm(form);
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('button, input[type="submit"], [role="button"], a');
    if (!button) return;

    var text = (button.textContent || button.value || '').trim().toLowerCase();
    var looksLikeAdd = text.indexOf('add to cart') !== -1 || text.indexOf('add to bag') !== -1 || button.name === 'add' || button.getAttribute('name') === 'add';
    var form = button.closest && button.closest('form[action*="/cart/add"], form[action*="cart/add"]');

    if (!looksLikeAdd && !form) return;

    var id = variantFromElement(button) || variantFromForm(form);
    if (isFrozen(id)) showWarning();
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"], form[action*="cart/add"]')) return;
    var id = variantFromForm(form);
    if (isFrozen(id)) showWarning();
  }, true);

  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      try {
        var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
        if (url.indexOf('/cart/add') !== -1 && args[1] && args[1].body) {
          var body = args[1].body;
          var id = '';
          if (body instanceof FormData) id = body.get('id');
          else if (body instanceof URLSearchParams) id = body.get('id');
          else if (typeof body === 'string') {
            try {
              var parsed = JSON.parse(body);
              id = parsed.id || (parsed.items && parsed.items[0] && parsed.items[0].id) || '';
            } catch (err) {
              try { id = new URLSearchParams(body).get('id'); } catch (err2) {}
            }
          }
          if (isFrozen(id)) showWarning();
        }
      } catch (err3) {}
      return originalFetch.apply(this, args);
    };
  }

  var OriginalXHR = window.XMLHttpRequest;
  if (OriginalXHR) {
    var originalOpen = OriginalXHR.prototype.open;
    var originalSend = OriginalXHR.prototype.send;
    OriginalXHR.prototype.open = function (method, url) {
      this.__tasteCartAddUrl = String(url || '');
      return originalOpen.apply(this, arguments);
    };
    OriginalXHR.prototype.send = function (body) {
      try {
        if (this.__tasteCartAddUrl && this.__tasteCartAddUrl.indexOf('/cart/add') !== -1 && body) {
          var id = '';
          if (body instanceof FormData) id = body.get('id');
          else if (typeof body === 'string') id = new URLSearchParams(body).get('id');
          if (isFrozen(id)) showWarning();
        }
      } catch (e) {}
      return originalSend.apply(this, arguments);
    };
  }
})();